<div class="sidebar">
  <app-menu></app-menu>
</div>

@if (show) {
  <div class="content">
    <router-outlet></router-outlet>
  </div>
}